import { Box, Divider, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

import { CarouselProductImage } from '@app/components/Company/CarouselProductImage';
import { CompanyLogo } from '@app/components/Company/CompanyLogo';
import { FadeInUpItem } from '@app/components/Company/FadeInUpItem';
import { Organization } from '@app/types/organization';

interface OrganizationFeatureProps {
  organization: Organization;
}

export function OrganizationFeature({
  organization,
}: OrganizationFeatureProps): ReactElement {
  return (
    <Stack
      maxWidth={1000}
      mx="auto"
      justifyContent="center"
      px={{ sm: 1, xs: 2.5 }}
    >
      <Box
        mt={3}
        mb={3}
        mx="auto"
        display={{ sm: 'none' }}
        width={{ xs: '90%' }}
      >
        <CompanyLogo
          companyName={organization.name}
          logoUrl={organization?.customFields?.companyLogo?.url}
          sx={{
            maxWidth: 'unset',
            width: '100%',
          }}
        />
      </Box>

      <FadeInUpItem>
        <Typography
          pb={3}
          fontSize={{ sm: 24, xs: 16 }}
          fontWeight={700}
          textAlign={{ sm: 'center', xs: 'left' }}
        >
          {organization?.customFields?.subText}
        </Typography>

        <Divider sx={{ mb: 6 }} color="#b4b4b4" />
      </FadeInUpItem>

      <Stack direction={{ sm: 'row', xs: 'column' }} spacing={7} mb={2}>
        <FadeInUpItem>
          <Stack width={{ sm: 430, xs: '100%' }}>
            <CarouselProductImage
              images={
                organization.customFields?.mainImages?.map(
                  (item) => item.url ?? ''
                ) ?? []
              }
            />

            <Typography fontWeight={700} py={3}>
              〈 施工エリア 〉
            </Typography>

            <Typography color="#3e86eb">
              {organization.customFields?.constructionArea}
            </Typography>
          </Stack>
        </FadeInUpItem>
        <Stack width="100%">
          <FadeInUpItem delay={0.5}>
            <Typography bgcolor="#00A0FF" color="white" p={1}>
              会社の特徴
            </Typography>

            {organization.customFields?.features?.map((feature, index) => (
              <Stack
                key={index}
                direction="row"
                alignItems="center"
                spacing={1}
                borderBottom={0.3}
                borderColor="#E0E0E0"
                py={2}
              >
                <Box
                  width={16}
                  height={16}
                  borderRadius="50%"
                  bgcolor="#00A0FF"
                />
                <Typography fontWeight={700}>{feature}</Typography>
              </Stack>
            ))}

            <Typography
              fontWeight={700}
              fontSize={20}
              borderLeft={3}
              borderColor="#3287E1"
              py={2}
              my={3}
              pl={2}
            >
              {organization?.customFields?.mainCatch}
            </Typography>

            <Typography lineHeight={2} sx={{ whiteSpace: 'pre-wrap' }}>
              {organization?.customFields?.subCatch}
            </Typography>
          </FadeInUpItem>
        </Stack>
      </Stack>
    </Stack>
  );
}
